import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {IApiContent} from "./api";
import {Config} from "@lib/cms/cms";

@Injectable()
export class ApiService {

    /**
     * API URL
     */
    private API_URL: string;

    /**
     * PREFIX URL
     */
    private readonly PREFIX_URL: string = '/cms';

    /**
     * CONFIG URL
     */
    private readonly CONFIG_URL: string = '/config';

    /**
     *
     * @param _http
     */
    public constructor(private _http: HttpClient) {

    }

    /**
     * Définit l'URL d'accès à l'API
     *
     * @param apiUrl
     */
    public setApiUrl(apiUrl: string): void {

        this.API_URL = apiUrl;
    }


    /**
     * Retourne l'api prefix
     */
    public getApiUrl(withPrefix: boolean): string {

        if(withPrefix){
            return this.API_URL + this.PREFIX_URL;
        }

        return this.API_URL;
    }

    /**
     * Retourne la configuration nécessaire au chargement d'une page
     *
     * @returns {Observable<Config>}
     */
    public getConfig(): Observable<Config> {

        return this._http.get<Config>(`${this.API_URL}${this.PREFIX_URL}${this.CONFIG_URL}`);
    }

    /**
     * Retourne le contenu d'une page existante en fonction de son ID
     * La configuration nécessaire au chargement d'une page est également retournée
     *
     * @param {string} contentId
     * @param {string} context
     * @returns {Observable<IApiContent>}
     */
    public getContent(contentId: string, context: string): Observable<IApiContent> {
        return this._http.get<IApiContent>(`${this.API_URL}${this.PREFIX_URL}` + '/load', {
            params: {
                content_id: contentId,
                context: context
            }
        });
    }
}
